/**
 * Created by Christof Sander on 07.02.2017.
 */

var utils = require('../lib/utils');
const MD5 = require('md5.js');
window.jQuery = window.$ = utils.$ = require('jquery');
utils.i18next.wrapper = require('./i18next');

utils.md5 = function(data){
    return new MD5().update(data).digest('hex')
}

module.exports = utils;
